module.exports = __webpack_public_path__ + "static/img/DALL·E-2024-12-02-20.29.81d89170.jpg";